import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { swayThemes, readyCheckThemes } from '@/config/themes'

let themeName = 'sway'

try {
    themeName = process.env.VUE_APP_PRODUCT_ENVIRONMENT
} catch(e) {
    // use default
}

const themes = themeName === 'sway' ? swayThemes : readyCheckThemes

export default createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'light',
        themes: {
            light: themes.light,
            dark: themes.dark
        }
    },
    icons: {
        defaultSet: 'mdi',
    },
})
